import { Store } from 'vuex';
import { RootState } from '@/store/types';
import { FilterableGridViewModel } from '@/modules/FilterableGridModule/FilterableGridModule.types';
import registerFilterableGrid from '@/modules/FilterableGridModule/FilterableGridModule.store';

export default async (store: Store<RootState>, data: FilterableGridViewModel) =>
  registerFilterableGrid(store, data);
